module.exports = __webpack_public_path__ + "static/dinersclub-logo-small-94ca91560b05bd66696151d978073240.svg";